<template>
    <div class="content content-page bookmark">
        <div class="container">
            <div class="row">

                <projectsidebarpostulante></projectsidebarpostulante>

                <div class="col-xl-9 col-lg-8">
                    <div class="dashboard-sec payout-section freelancer-statements">
                        <!-- <div class="page-title portfolio-title">
                            <h3 class="mb-0">Datos Personales</h3>
                        </div> -->
                        <div>
                            <div class="text-center onboard-head">
                            <h2>Información Personal</h2>
                            <p>Cuéntanos un poco más sobre ti.</p>
                            <!-- <p>Tell a bit about yourself. This information will appear on your public profile, so that potential
                                buyers can get to know you better.</p> -->
                            </div>
                            <!-- <info_personal></info_personal> -->
                            <div class="field-item personal-info space-info">
                            <form @submit.prevent="updatePersonalData">
                                <div class="row">
                                    <div class="col-md-12 col-lg-12">
                                        <div class="pro-form-img">
                                        <div class="profile-pic">
                                            <div class="img-preview">
                                            <img v-if="imgPreviewApplicant" :src="imgPreviewApplicant" style="width:100%; height:100%;"/>
                                            </div>
                                            {{imgPreviewApplicant ? '' : 'Foto de Perfil'}}
                                        </div>
                                        <div class="upload-files">
                                            <label class="file-upload image-upbtn">
                                            <i class="feather-upload me-2"></i>Cargar Foto
                                            <input 
                                            type="file"
                                            class="form-control" 
                                            name="txt-imagen" 
                                            accept="image/png, image/gif, image/jpeg"
                                            @change="handlePhotoChangeApplicant"
                                            />
                                            </label>
                                            <span>Se recomienda que la foto debe tener un tamaño de 450x450 y un tamaño máximo de 5mb.</span>
                                        </div>
                                        </div>
                                    </div>
                                    <div class="col-md-4 col-lg-4">
                                        <div class="input-block">
                                        <label class="form-label">Nombres</label>
                                        <input type="text" class="form-control" v-model="name"/>
                                        </div>
                                    </div>
                                    <div class="col-md-4 col-lg-4">
                                        <div class="input-block">
                                        <label class="form-label">Apellido Paterno</label>
                                        <input type="text" class="form-control" v-model="firstSurname"/>
                                        </div>
                                    </div>
                                    <div class="col-md-4 col-lg-4">
                                        <div class="input-block">
                                        <label class="form-label">Apellido Materno</label>
                                        <input type="text" class="form-control" v-model="secondSurname"/>
                                        </div>
                                    </div>
                                    <div class="col-md-6 col-lg-4">
                                        <div class="input-block">
                                        <label class="form-label">Tipo de Documento</label>
                                        <vue-select :options="typeDocs" id="type_doc" placeholder="Seleccionar" v-model="selectedTypeDoc"/>
                                        </div>
                                    </div>
                                    <div class="col-md-4 col-lg-4">
                                        <div class="input-block">
                                        <label class="form-label">N° Documento</label>
                                        <input type="text" class="form-control" v-model="n_doc"/>
                                        </div>
                                    </div>
                                    <div class="col-md-4 col-lg-4">
                                        <div class="input-block">
                                        <label class="form-label">Celular</label>
                                        <input type="text" class="form-control" v-model="phone"/>
                                        </div>
                                    </div>

                                    <div class="col-md-3 col-lg-3">
                                        <div class="input-block">
                                        <label class="form-label">Fecha de Nacimiento</label>
                                        <div class="cal-icon">
                                            <datepicker
                                            v-model="birthdate"
                                            placeholder="Elegir Fecha"
                                            class="form-control datetimepicker"
                                            :editable="true"
                                            :clearable="false"
                                            />
                                        </div>
                                        </div>
                                    </div>
                                    <div class="col-md-3 col-lg-3">
                                        <div class="input-block">
                                        <label class="form-label">Género</label>
                                        <vue-select :options="genders" id="gender" placeholder="Seleccionar" v-model="selectedGender"/>
                                        </div>
                                    </div>
                                    <div class="col-md-3 col-lg-3">
                                        <div class="input-block">
                                        <label class="form-label">Estado Civil</label>
                                        <vue-select :options="maritalStatus" id="marital_status" placeholder="Seleccionar" v-model="selectedMaritalStatus"/>
                                        </div>
                                    </div>
                                    <div class="col-md-3 col-lg-3">
                                        <div class="input-block">
                                        <label class="form-label">Nacionalidad</label>
                                        <input type="text" class="form-control" v-model="nationality"/>
                                        </div>
                                    </div>

                                    <div class="col-md-3 col-lg-3">
                                        <div class="input-block">
                                        <label class="form-label">Pais</label>
                                        <input type="text" class="form-control" v-model="country"/>
                                        </div>
                                    </div>
                                    <div class="col-md-3 col-lg-3">
                                        <div class="input-block">
                                        <label class="form-label">Departamento</label>
                                        <input type="text" class="form-control" v-model="departament"/>
                                        </div>
                                    </div>
                                    <div class="col-md-3 col-lg-3">
                                        <div class="input-block">
                                        <label class="form-label">Provincia</label>
                                        <input type="text" class="form-control" v-model="province"/>
                                        </div>
                                    </div>
                                    <div class="col-md-3 col-lg-3">
                                        <div class="input-block">
                                        <label class="form-label">Distrito</label>
                                        <input type="text" class="form-control" v-model="district"/>
                                        </div>
                                    </div>

                                    <div class="col-md-12">
                                        <div class="input-block min-characters">
                                        <label class="form-label">¿Como te describirías?</label>
                                        <textarea class="form-control" rows="5" v-model="personalDescription"></textarea>
                                        </div>
                                    </div>

                                    <div class="col-md-3">
                                        <div class="input-block min-characters">
                                        <label class="custom_check">
                                            <input type="checkbox" name="select_time" v-model="availabTravel" /><span
                                            class="checkmark border-agv"
                                            ></span>
                                            Disponibilidad para viajar
                                        </label>
                                        </div>
                                    </div>
                                    <div class="col-md-3">
                                        <div class="input-block min-characters">
                                        <label class="custom_check">
                                            <input type="checkbox" name="select_time" v-model="availabChangeResid" /><span
                                            class="checkmark border-agv"
                                            ></span>
                                            Disponilidad para cambiar de residencia
                                        </label>
                                        </div>
                                    </div>
                                    <div class="col-md-3">
                                        <div class="input-block min-characters">
                                        <label class="custom_check">
                                            <input type="checkbox" name="select_time" v-model="driversLicense" /><span
                                            class="checkmark border-agv"
                                            ></span>
                                            Licencia de conducir
                                        </label>
                                        </div>
                                    </div>
                                    <div class="col-md-3">
                                        <div class="input-block min-characters">
                                        <label class="custom_check">
                                            <input type="checkbox" name="select_time" v-model="disability"/><span
                                            class="checkmark border-agv"
                                            ></span>
                                            Discapacidad
                                        </label>
                                        </div>
                                    </div>

                                    <div class="col-md-6 col-lg-6">
                                        <div class="input-block">
                                        <label class="form-label">Expectativa salarial</label>
                                        <input type="text" class="form-control" v-model="salary_expect"/>
                                        </div>
                                    </div>

                                    <div class="col-md-6 col-lg-6" style="padding-top: 30px;">
                                        <div v-if="actualCV">
                                            <a
                                            :href="actualCV"
                                            class="btn btn-sm btn-agv-dos"
                                            style="font-size:14px;margin-left:10px; padding: 10px 16px;"
                                            target="_blank"
                                            ><i class="fa-solid fa-file-lines"> Ver CV Actual</i>
                                            </a>
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-md-4"></div>
                                    <div class="col-md-4">
                                        <button class="btn btn-primary pt-1" type="submit" style="width:100%; padding-top:30px; padding-bottom:10px;">Actualizar Datos</button>
                                    </div>
                                </div>
                            </form>
                            </div>
                            
                        </div>
                        <!-- /Personal Info -->
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- Pie de Página -->
    <footeragv></footeragv>
</template>

<script>
    import axiosIns from '@/plugins/axios.js';
    import { ref } from "vue";
    import { Form, Field } from "vee-validate";
    export default {
    components: {
        Form,
        Field,
    },
    data() {
        return {
            id_applicant: JSON.parse(localStorage.getItem('userData'))?.id_usuario,
            
            showPassword: false,
            password: null,
            emailError: "",
            passwordError: "",
            currentStep: 1,
            totalSteps: 4,
            
            username: null,
            email: null,
            password: null,

            name: null,
            firstSurname: null,
            secondSurname: null,
            selectedTypeDoc: null,
            typeDocs: ["C.E.","DNI","PASAPORTE"],
            n_doc: null,
            phone: null,
            birthdate: null,
            selectedGender: null,
            genders: ["Masculino","Femenino"],
            selectedMaritalStatus : null,
            maritalStatus : ["Soltero","Casado","Divorciado","Conviviente"],
            nationality: null,
            country: null,
            departament: null,
            province: null,
            district: null,
            salary_expect: null,
            personalDescription: null,
            availabTravel: false,
            availabChangeResid: false,
            driversLicense: false,
            disability: false,

            schoolCompleted: null,

            levelLenguage: ["Basico", "Intermedio", "Avanzado"],
            academicDegree: ["Tecnico", "Universitario","Maestria","Doctorado"],
            socialNetworks: ["Linkedin", "Facebook", "Instagram", "Tik Tok"],
            schoolCompleted: "",
            newEducation: {
            degree: "",
            university: "",
            career: "",
            startDate: "",
            endDate: "",
            actuallyStudying: 'NO',
            },
            educations: [],
            newExperience: {
            companyName: "",
            position: "",
            mount: "",
            description: "",
            startDate: "",
            endDate: "",
            actuallyWorking: 'NO',
            nameContact:"",
            workPositionContact:"",
            phoneContact:"",
            emailContact:"",
            },
            experiences: [],
            newLanguage: {
            language: "",
            level: ""
            },
            languages: [],
            
            fileCvApplicant:null,
            fileCvApplicantName:null,
            imgApplicant:null,
            imgPreviewApplicant:null,
            bumeranInvitation: false,
            termsAccepted: 'NO',

            actualCV:null,
            // startdate: currentDate,
        };
    },
    mounted(){
        this.getApplicant()
    },
    methods:{
        getApplicant(){

            const yo = this
            const data = JSON.stringify({
                id : yo.id_applicant,
            })

            const config = {
                method: 'post',
                url: '/talentoagv/getApplicant/',
                headers: {
                    'Content-Type': 'application/json'
                },
                data: data,
            }

            axiosIns(config)
                .then(function (response) {
                    console.log(response)
                    if (response.data['is_error'] === false){
                        let datosUsuario = response.data['result'][0]
                        yo.name = datosUsuario['name']
                        yo.firstSurname = datosUsuario['first_surname']
                        yo.secondSurname= datosUsuario['second_surname']
                        yo.selectedTypeDoc = datosUsuario['type_doc']
                        yo.n_doc = datosUsuario['n_doc']
                        yo.phone = datosUsuario['n_phone']
                        yo.birthdate = new Date(datosUsuario['birthdate'])
                        yo.selectedGender = datosUsuario['gender']
                        yo.selectedMaritalStatus = datosUsuario['marital_status']
                        yo.nationality = datosUsuario['nationality']
                        yo.country = datosUsuario['country']
                        yo.departament = datosUsuario['departament']
                        yo.province = datosUsuario['province']
                        yo.district = datosUsuario['district']
                        yo.salary_expect = datosUsuario['salary_expect']
                        yo.personalDescription = datosUsuario['pers_description']
                        yo.availabTravel = datosUsuario['availab_travel']
                        yo.availabChangeResid = datosUsuario['availab_change_resid']
                        yo.driversLicense = datosUsuario['drivers_license']
                        yo.disability = datosUsuario['disability']

                        yo.actualCV = datosUsuario['cv_s3_url']
                    }
            })
            .catch(function (error) {
                console.log(error);
                // yo.$toastr.error(response.data['message'], 'Error')
            })
            .finally(function (){
            
            })

        },

        updatePersonalData(){

            const yo = this
            const data = JSON.stringify({
                id: yo.id_applicant,
                name: yo.name,
                firstSurname: yo.firstSurname,
                secondSurname: yo.secondSurname,
                selectedTypeDoc: yo.selectedTypeDoc,
                n_doc: yo.n_doc,
                phone: yo.phone,
                birthdate: yo.birthdate,
                selectedGender: yo.selectedGender,
                selectedMaritalStatus : yo.selectedMaritalStatus,
                nationality: yo.nationality,
                country: yo.country,
                departament: yo.departament,
                province: yo.province,
                district: yo.district,
                salary_expect: yo.salary_expect,
                personalDescription: yo.personalDescription,
                availabTravel: yo.availabTravel,
                availabChangeResid: yo.availabChangeResid,
                driversLicense: yo.driversLicense,
                disability: yo.disability,
                block : 'personal_data',
            })

            const config = {
                method: 'post',
                url: '/talentoagv/updateApplicant/',
                headers: {
                    'Content-Type': 'application/json'
                },
                data: data,
            }

            axiosIns(config)
                .then(function (response) {
                    // if (response.data['is_error'] === false){
                    //     yo.$toastr.success('Usuario actualizado', 'Exito')
                    // }
            })
            .catch(function (error) {
                console.log(error);
            })
            .finally(function (){
            
            })


        },
    }

}
</script>